export const environment = {
  API_BASE_URL: "https://docuty-api-test.insirion.com",
  AUTH_DOMAIN: "docuty-test.eu.auth0.com",
  AUTH_CLIENT_ID: "6T6UdehfXgAD8ceZeNiTlxNn3vfWPXif",
  AUTH_AUDIENCE: "https://docuty-test.insirion.com",
  SUPPORT_MAIL: "info@docuty.de",
  BACKOFFICE_VERSION: "development-388f5ec",
  BACKOFFICE_COMMIT_HASH: "388f5ec",
  IS_PRODUCTION: false,
  SKIP_BACKOFFICE_AUTH: true
};
